import React from 'react';
import type { FC } from 'react';
import { Key, Text, useInput } from '@wix/cli-ui-kit';
import { Trans, useTranslation } from '@wix/cli-i18n';
import { useWixCliAppBi } from '../../bi/index.js';

interface Props {
  onClose: () => void;
}

export const CloseScreen: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation();
  const bi = useWixCliAppBi();

  useInput((_, key) => {
    if (key.escape) {
      bi.cliAction({
        question: t('general.close_screen'),
        questionKey: 'general.close_screen',
        action: 'close',
        key: 'esc',
      });
      onClose();
    }
  });

  return (
    <Text skin="secondary">
      <Trans
        i18nKey="general.close_screen"
        components={[<Key value="esc" skin="secondary" />]}
      />
    </Text>
  );
};
